import React from "react";
import ICardWidgetProps from "../../../../../../model/interface/dataStorage/card/ICardWidgetProps";
import IframeWidget from "../../../widget/IframeWidget";
import ICardWidgetIframe from "../../../../../../model/interface/dataStorage/card/ICardWidgetIframe";
import {Col, Row} from "antd";

interface IProps extends ICardWidgetProps<ICardWidgetIframe> {
}

class CardWidgetIframe extends React.Component<IProps> {
    renderItem(url: string, options: ICardWidgetIframe) {
        const isImage = /\.(jpe?g|png|webp|gif|bmp)(\?.*)?$/i.test(url);

        if (isImage) {
            return (
                <div style={{
                    width: '100%',
                    height: options.height || 500,
                    backgroundColor: '#2b2b2b',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    borderRadius: 4
                }}>
                    <img
                        src={url}
                        alt="Document"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            );
        }

        // PDFs stay in the iframe widget
        return <IframeWidget {...this.props} options={{ ...options, url }} />;
    }

    render() {
        const { functions, options } = this.props;
        const url = options.field ? functions.getValue(options.field) : options.url;

        if (!url) {
            return null;
        }

        if (Array.isArray(url)) {
            return (
                <Row gutter={[12, 12]}>
                    {url.map((item) => (
                        <Col span={24} key={item}>
                            {this.renderItem(item, options)}
                        </Col>
                    ))}
                </Row>
            );
        }

        return this.renderItem(url, options);
    }
}


export default CardWidgetIframe

